import request from './request'

/**
 * 上传文件
 * @param {File} file - 文件对象
 * @param {string} [module] - 业务模块（可选，用于分类存储）
 * @param {string} [bucket] - 存储桶标识（如 public、private），不传则使用默认桶
 */
export function uploadFile(file, module = 'avatar', bucket = 'public') {
  const formData = new FormData()
  formData.append('file', file)
  if (module) {
    formData.append('module', module)
  }
  if (bucket) {
    formData.append('bucket', bucket)
  }
  return request.post('/file/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 获取文件访问 URL（私有桶返回预签名 URL，有时效，不宜持久化，用时现取）
 * @param {string} key 文件 key
 * @param {string} [bucket] 存储桶标识，默认 private
 * @returns {Promise<string>} 可访问 URL（响应拦截器已解包 Result.data）
 */
export function getFileUrl(key, bucket = 'private') {
  // key 形如 module/yyyyMMdd/uuid.ext 含斜杠，后端以 /url/** 全段捕获，不得 encodeURIComponent（Tomcat 默认拒绝 %2F）
  return request.get(`/file/url/${key}`, { params: { bucket } })
}
